




























































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { User } from '@/types/Users'
import { Shift } from '@/types/Jobs'
import { createShift, loadShift, updateShift } from '@/services/shifts'
import { loadJob } from '@/services/jobs'
import { exists } from '@/util/inputValidation'

import RichtextField from '@/components/inputs/RichtextField.vue'
import TaskListInput from '@/components/inputs/TaskListInput.vue'
import RecurringDateInput from '@/components/inputs/RecurringDateInput.vue'
import DatetimeInput from '@/components/inputs/DatetimeInput.vue'

const timeValidate = (errorMessage: string) => (value: any) =>
  /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(value)

interface UnassignedContractor {
  id: number
}

@Component({
  components: {
    RichtextField,
    TaskListInput,
    RecurringDateInput,
    DatetimeInput,
  },
})
export default class EditShiftDialog extends Vue {

  @Prop({ type: Number   }) readonly shiftId?: number
  @Prop({ default: false }) readonly opened!: boolean
  @Prop({ type: Number    }) readonly jobId?: number // If no jobId specified, then we add a job selector to the dialog
  get jobIdComputed() {
    return this.jobId ?? this.editedShift.job_id
  }

  @Prop({ type: Object }) readonly time?: {
    start: Date
    end: Date
  }

  get startEndTimes() {
    if (this.time) {
      return this.time
    }
    else if (this.shiftId) {
      const shift = this.$store.getters.shift(this.shiftId)
      return {
        start: shift.time_begin,
        end: shift.time_end,
      }
    }
    return undefined
  }

  initialState() {
    return {
      contractor_ids: [],
      site_locations: [],
      site_location: '',
      time_begin: '',
      time_end: '',
      notes: '',
      tasks: [],
    }
  }

  ends = 'on'
  editedShift: any = this.initialState()
  selectedJob: number | null = null
  recurData: any = {}
  isValid = false
  loading = false
  loadingJob = false
  rules = {
    location: [exists('Location required')],
    date: [exists('Date required')],
    timeBegin: [exists('Start time required'), timeValidate('Time invalid')],
    timeEnd: [exists('End time required'), timeValidate('Time invalid')],
  }

  @Watch('opened')
  async onOpened(opened: boolean) {
    if (!opened) return

    this.editedShift = this.initialState()

    // Editing existing shift, fill data
    if (this.shiftId) {
      if (!this.shift?.id) {
        try {
          this.loading = true
          await loadShift(this.$store, this.shiftId)
        }
        finally {
          this.loading = false
        }
      }

      if (!this.$store.getters.job(this.shift.job_id)?.contractors?.length) {
        console.log('no contractors')
        try {
          // If we don't have the contractor list, load it
          this.loadingJob = true
          await loadJob(this.$store, this.jobIdComputed || this.shift.job_id)
        }
        finally {
          this.loadingJob = false
        }
      }
      
      this.editedShift = { ...this.shift }
    }
    // Creating new shift, prefill fields
    else {
      if (this.contractors.length) this.editedShift.contractor_ids = [this.contractors[0]?.id]
    }
  }

  async onSelectedJob(jobId: number | null) {
    if (!jobId) return

    this.loadingJob = true
    // Query job to get the contractors data
    // TODO: Make route for only the contractors of a job
    try {
      await loadJob(this.$store, jobId)
      // When the job loads, for some reason the selected job gets cleared.
      // For now, just set it again. This method gets called again on change but there are no params passed, so no infinite loop.
      this.selectedJob = jobId
    }
    finally {
      this.loadingJob = false
    }
  }

  closeDialog() {
    this.editedShift = this.initialState()
    this.$emit('update:opened', false)
  }

  get jobs() {
    return this.$store.getters.jobs
  }

  get shift() {
    return this.$store.getters.shift(this.shiftId)
  }

  get contractors() {
    const jobId = this.jobIdComputed ?? this.selectedJob
    const contractors = this.$store.getters.job(jobId)?.contractors ?? []

    return contractors.sort((a: User, b: User) => {
      if (!a.name || !b.name) return 0
      return a.name > b.name ? 1 : -1
    })
  }

  contractorName(contractorId: number) {
    const e: any = this.contractors.find((e: User) => e.id == contractorId)
    if (contractorId > 0) return `${e.first_name} ${e.last_name}`
    return `Unassigned ${-contractorId}`
  }

  randomSiteLocation() {
    const examples = ['Front of store', 'Back of store', 'Outside', 'Front desk', 'Kitchen', 'Main site', 'West wing', 'East wing']
    return 'Ex. ' +  examples[Math.floor(Math.random() * examples.length)]
  }

  /*
    List of selected contractors contains negative IDs to represent unassigned contractors
    Every value has to be unique, so the values cannot be all 'null'. Before
    sending off the request to create the shift, the negative values are converted to nulls
  */
  lastId = -1
  addUnassignedContractor() {
    this.contractors.push({
      id: this.lastId,
    })
    this.editedShift.contractor_ids.push(this.lastId)
    this.lastId--
  }

  async updateShift() {
    this.loading = true

    // TODO: Validate shifts so that end time is after start time
    try {
      const editedShift = {
        ...this.editedShift,
        ...this.recurData
      }

      if (this.shiftId) {
        await updateShift(this.$store, editedShift)
        this.$emit('saved')
      }
      else {
        await createShift(
          this.$store,
          editedShift,
          this.jobIdComputed ?? this.selectedJob,
        )
      }

      this.closeDialog()
    } finally {
      this.loading = false
    }
  } 
}
